/* eslint-disable ember/classic-decorator-hooks */
import FirstOrderCommonCircuit from '../common/circuit';
import ActualFilterAmplitude from './actual-filter-amplitude';
import NoiseGroup from './noise-group';
import IdealOpAmp from './ideal-op-amp';
import HighPassFirstOrderCircuit from './circuit';

// First-order highpass. This inherits for first-order common. Most of the logic for creating
// the circuit components are in the base class.
export default class FirstOrderHighPassCircuit extends FirstOrderCommonCircuit {
  supportedComponents;
  actualFilterAmplitudeModel;
  noiseGroupModel;
  idealOpAmpModel;
  circuitModel;
  idealOpAmpValuePaths;
  opAmp;
  needReferenceStage = true;
  init() {
    super.init();
    this.actualFilterAmplitudeModel = ActualFilterAmplitude;
    this.noiseGroupModel = NoiseGroup;
    this.idealOpAmpModel = IdealOpAmp;
    this.circuitModel = HighPassFirstOrderCircuit;
    this.supportedComponents = ['c1', 'r1', 'r3', 'r4'];
    this.idealOpAmpValuePaths = ['r1', 'r3', 'r4'];
  }
}
